import React, {useEffect, useState} from 'react';
import {Button, Form, Grid, Header, Message, Segment} from 'semantic-ui-react';
import GetToken from "services/auth/get-token";
import SessionStorage from "store/session";
import {useNavigate} from "react-router-dom";
import {useBlockUI} from "../../shared/services/block-ui-service";

const LoginForm = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const navigate = useNavigate()
    const [loading, setLoading] = useState<boolean>(false);
    const blockUI = useBlockUI();
    useEffect(() => {
        blockUI?.setActive(loading)
    }, [loading]);

    const handleSubmit = async () => {
        const user = (await GetToken({email, password}))?.data?.data;
        user.isLogged = true;
        setLoading(true)
        await SessionStorage.saveSession(user)
        navigate('/')
        window.location.reload()
    };

    return (
        <div suppressContentEditableWarning
             style={{backgroundImage: 'url(/login_bg.png)', backgroundSize: 'cover'}}>
            <Grid textAlign='center' style={{height: '100vh'}} verticalAlign='middle'>
                <Grid.Column style={{maxWidth: 450}}>
                    <img src={'/logotipo.png'} style={{
                        maxHeight: '3rem',
                        objectFit: 'contain',
                        marginTop: 10,
                        marginBottom: 10,
                        paddingBottom: 5,
                        alignSelf: 'center',
                        width: '100%',
                    }} alt={'fleetgame'}/>
                    <Form size='large'>
                        <Header as={'h3'} color={'green'}>Portal Fleetgame</Header>
                        <Segment stacked>
                            <Form.Input
                                fluid
                                icon='user'
                                type={'email'}
                                iconPosition='left'
                                placeholder='E-mail'
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                            <Form.Input
                                fluid
                                icon='lock'
                                iconPosition='left'
                                placeholder='Senha'
                                type='password'
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />

                            <Button fluid size='large' color={'green'} onClick={handleSubmit}>
                                Login
                            </Button>
                            <div style={{ marginTop: '10px' }}>
                                <Button fluid size='large' basic
                                        onClick={
                                    () => navigate('/lost-password/')
                                }>
                                    Esqueci a senha
                                </Button>
                            </div>
                        </Segment>
                    </Form>
                </Grid.Column>
            </Grid>
        </div>
    );
};

export default LoginForm;
